import { loadGSAP } from '../../externals/gsap.js';

export const defaults = {
  origin: 'bottom',   // top | bottom | left | right | none
  duration: 0.8,
  delay: 0,
  distance: 40,       // px — slide offset before fade
  ease: 'power2.out',
  mode: 'element',    // element | words | letters | lines
  stagger: 0.04,      // seconds between each unit in text modes
};

export default async function fadein(el, options) {
  await loadGSAP();
  const { gsap } = window;

  const duration  = parseFloat(options.duration);
  const delay     = parseFloat(options.delay);
  const distance  = parseFloat(options.distance);
  const stagger   = parseFloat(options.stagger);
  const { origin, ease, mode } = options;

  const from = { opacity: 0 };
  if (origin === 'bottom') from.y =  distance;
  if (origin === 'top')    from.y = -distance;
  if (origin === 'left')   from.x = -distance;
  if (origin === 'right')  from.x =  distance;

  if (mode === 'element') {
    gsap.from(el, { ...from, duration, delay, ease });
    return;
  }

  const targets = splitText(el, mode);
  gsap.from(targets, { ...from, duration, delay, stagger, ease });
}

function splitText(el, mode) {
  const text = el.textContent.trim();
  el.textContent = '';

  if (mode === 'words') {
    return text.split(/\s+/).map((word, i, arr) => {
      const span = document.createElement('span');
      span.textContent = i < arr.length - 1 ? word + ' ' : word;
      span.style.display = 'inline-block';
      el.appendChild(span);
      return span;
    });
  }

  if (mode === 'letters') {
    return [...text].map(char => {
      const span = document.createElement('span');
      span.textContent = char === ' ' ? ' ' : char;
      span.style.display = 'inline-block';
      el.appendChild(span);
      return span;
    });
  }

  if (mode === 'lines') {
    // Step 1 — temporary word spans to measure line breaks
    const words = text.split(/\s+/);
    const tempSpans = words.map((word, i) => {
      const span = document.createElement('span');
      span.textContent = i < words.length - 1 ? word + ' ' : word;
      span.style.display = 'inline';
      el.appendChild(span);
      return span;
    });

    // Step 2 — group by vertical position
    const lineGroups = [];
    let lastTop = null;
    tempSpans.forEach(span => {
      const top = Math.round(span.getBoundingClientRect().top);
      if (top !== lastTop) { lineGroups.push([]); lastTop = top; }
      lineGroups[lineGroups.length - 1].push(span);
    });

    // Step 3 — rebuild as clipped line wrappers
    el.innerHTML = '';
    return lineGroups.map(spans => {
      const outer = document.createElement('span');
      outer.style.cssText = 'display:block; overflow:hidden;';
      const inner = document.createElement('span');
      inner.style.display = 'block';
      spans.forEach(s => inner.appendChild(s));
      outer.appendChild(inner);
      el.appendChild(outer);
      return inner;
    });
  }

  return [el];
}
